<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item label="商品名称：" :rules="[{ required: true, message: '请填写商品名称' }]" prop="model.product_name">
      <el-input v-model="form.model.product_name" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品编码："><el-input v-model="form.model.product_no" class="max-w460"></el-input></el-form-item>
    <el-form-item label="所属分类：" :rules="[{ required: true, message: '你选择商品分类' }]" prop="model.category_id">
      <el-select v-model="form.model.category_id">
        <template v-for="cat in form.catgory">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>


    <el-form-item label="商品分组：" v-auth="'/product/groups/index'">
      <el-select v-model="form.model.groups_id" multiple filterable placeholder="请选择">
        <el-option
          v-for="item in form.groups"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>


    <el-form-item label="商品标签：" v-auth="'/product/label/index'">
      <el-select v-model="form.model.label_id" multiple filterable placeholder="请选择">
        <el-option
          v-for="item in form.label"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="商品属性：">
      <el-checkbox v-model="form.model.is_recommend">推荐</el-checkbox>
      <el-checkbox v-model="form.model.is_hot">热卖</el-checkbox>
      <el-checkbox v-model="form.model.is_new">新品</el-checkbox>
      <el-checkbox v-model="form.model.is_show">隐藏</el-checkbox>
      <el-checkbox v-model="form.model.is_agri">农产品</el-checkbox>
    </el-form-item>

    <el-form-item label="商品图片：" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
      <div slot="label">商品图片：<gm-tips content="建议尺寸750x750" /></div>
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.image" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>



    <el-form-item label="检测报告图片：" prop="model.imageqa">
      <div slot="label">检测报告图片：<gm-tips content="建议尺寸690x985" /></div>
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.imageqa">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.imageqa" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgqa(index)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUploadqa"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>






    <el-form-item label="商品横向图：" prop="imagerow">
      <div slot="label">商品横向图：<gm-tips content="建议尺寸750x500" /></div>
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload({ type: 'imagerow' })">选择图片
        </el-button>
        <div class="draggable-list">
          <div v-if="form.model.imagerow !== ''" class="img item">
            <img :src="form.model.imagerow" width="100" height="100" alt="imagerow"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgImagerow"><i class="el-icon-close"></i></a>
          </div>
        </div>
      </el-row>
    </el-form-item>

    <el-form-item label="视频封面图：" prop="poster">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload({ type: 'poster' })">选择图片
        </el-button>
        <div class="draggable-list">
          <div v-if="form.model.poster !== ''" class="img item">
            <img :src="form.model.poster" width="100" height="100" alt="poster"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgPoster"><i class="el-icon-close"></i></a>
          </div>
        </div>
      </el-row>
    </el-form-item>


  <el-form-item label="商品分享图：" prop="imageshare">
    <div slot="label">商品分享图：<gm-tips content="建议尺寸500x400" /></div>
    <el-row>
      <el-button icon="el-icon-picture-outline" @click="openUpload({ type: 'imageshare' })">选择图片
      </el-button>
      <div class="draggable-list">
        <div v-if="form.model.imageshare !== ''" class="img item">
          <img :src="form.model.imageshare" width="100" height="100" alt="imageshare"/>
          <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgImageshare"><i class="el-icon-close"></i></a>
        </div>
      </div>
    </el-row>
  </el-form-item>




    <el-form-item label="主图视频：" prop="video">
      <el-input type="text" v-model="form.model.video" placeholder="请选择视频" class="max-w460">
        <template slot="append">
          <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频
          </el-button>
        </template>
      </el-input>
    </el-form-item>

    <el-form-item label="推广视频：" prop="dvideo">
      <el-input type="text" v-model="form.model.dvideo" placeholder="请填写推广视频路径" class="max-w460">
        <el-input v-model="form.model.dvideo" class="max-w460"></el-input>
      </el-input>
    </el-form-item>

    <el-form-item label="商品卖点：">
      <el-input type="textarea" v-model="form.model.selling_point" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="商品关键字：">
      <el-input type="textarea" v-model="form.model.pkeyword" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="升级礼包关联：">
      <el-input v-model="form.model.pgrefer" class="max-w460"></el-input>
      <div class="red">用于升级大礼包关联设定：商品1ID_商品1数量,商品1ID_商品1数量,；如：100_3,(商品ID:100,数量3)</div>
    </el-form-item>


    <div class="common-form"  v-auth="'/product/skucate/index'">属性分类</div>
    <el-form-item v-for="(item,index) in form.skucate" :key="index" :label="`${item.name}:`" v-auth="'/product/skucate/index'">
      <el-select v-model="form.model.skucate[item.id]" multiple clearable  placeholder="请选择">
        <el-option
          v-for="it in item.child"
          :key="it.id"
          :label="it.name"
          :value="it.id">
        </el-option>
      </el-select>
    </el-form-item>


    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>

    <!--商品检测报告组件-->
    <Upload v-if="isProductUploadqa" :config="{ total: 9 }" :isupload="isProductUploadqa" @returnImgs="returnProductImgsFuncqa">上传图片</Upload>



    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片
    </Upload>

    <!--上传图片组件-->
    <Upload v-if="isuploadrow" :isupload="isuploadrow" type="image" @returnImgs="returnImgsFuncRow">上传商品横向图
    </Upload>

    <!--上传图片组件-->
    <Upload v-if="isuploadshare" :isupload="isuploadrsharee" type="image" @returnImgs="returnImgsFuncShare">上传商品分享图
    </Upload>

    <!--上传视频组件-->
    <Upload v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频
    </Upload>


  </div>
</template>

<script>

import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false,
      isVideoUpload: false,
      isupload: false,
      isuploadrow: false,
      isuploadshare: false,

      isProductUploadqa: false,
    };
  },
  inject: ['form'],
  created() {

  },
  methods: {

    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.image.concat(e);
        this.$set(this.form.model, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.image.splice(index, 1);
    },
    /*上传封面图*/
    openUpload(e) {
      if (e.type === "poster") {
        this.isupload = true;
      }else if (e.type === "imagerow") {
        this.isuploadrow = true;
      }else if (e.type === "imageshare") {
        this.isuploadshare = true;
      } else {
        this.avatarUpload = true;
      }
    },
    /* 打开视频 */
    openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      console.log(e);
      if (e != null && e.length > 0) {
        this.form.model.video = e[0].file_path;
      }
      this.isVideoUpload = false;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.model.poster = e[0].file_path;
      }
      this.isupload = false;
    },
    /*获取图片*/
    returnImgsFuncRow(e) {
      if (e != null && e.length > 0) {
        this.form.model.imagerow = e[0].file_path;
      }
      this.isuploadrow = false;
    },
    /*获取图片*/
    returnImgsFuncShare(e) {
      if (e != null && e.length > 0) {
        this.form.model.imageshare = e[0].file_path;
      }
      this.isuploadshare = false;
    },
    /* 删除封面 */
    deleteImgPoster() {
      this.form.model.poster = "";
    },
    /* 删除商品横向图 */
    deleteImgImagerow() {
      this.form.model.imagerow = "";
    },
    /* 删除商品分享图 */
    deleteImgImageshare() {
      this.form.model.imageshare = "";
    },




    /*删除商品图片*/
    deleteImgqa(index) {
      this.form.model.imageqa.splice(index, 1);
    },
    /*打开上传图片*/
    openProductUploadqa: function() {
      this.isProductUploadqa = true;
    },

    /*上传商品图片*/
    returnProductImgsFuncqa(e) {
      if (e != null) {
        let imgs = this.form.model.imageqa.concat(e);
        this.$set(this.form.model, 'imageqa', imgs);
      }
      this.isProductUploadqa = false;
    },


  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue